<template>
    <Cascader :value="targetIdList" :data="dataList" :load-data="loadData" @on-change="onTargetChange"></Cascader>
</template>

<script>
export default {
    model: {
        prop: "value",
        event: "target-type-change"
    },
    props: {
        value: String
    },
    data() {
        return {
            dataList: [],
            targetIdList: [],
        };
    },
    watch: {
        value: function (newVal, oldVal) {
            if (newVal && !this.loaded) {
                let param = {
                    url: 'http://CORE-TARGET/messageService/baseInfoService/queryTarget',
                    body: { code: this.value }
                }

                this.invoke(param).then(({ targetClass, targetSort, targetType, superCode, code }) => {
                    this.loaded = true;
                    this.targetIdList = [targetClass, targetSort, targetType, superCode, code];
                })
            }
        }
    },

    computed: {
    },

    created() {
        this.queryTargetClass();
    },
    methods: {
        openCancels(){
            this.targetIdList =[]
        },
        queryTargetClass() {
            let param = {
                url:
                    "CORE-TARGET/messageService/baseInfoService/queryAllTargetClasses",
                body: {}
            };
            this.invoke(param).then(res => {
                this.dataList = res.map(({ code, name }) => {
                    return { value: code, label: name, children: [], loading: false };
                });
            });
        },
        async loadData(item, callback) {
            item.loading = true;
            let data = {
                url: "CORE-TARGET/messageService/baseInfoService/querySubTypes",
                body: { superCode: item.value }
            };
            let subTypeList = await this.invoke(data);
            item.children = subTypeList.map(({ code, name, typeLevel }) => {
                let obj = { value: code, label: name };
                if (typeLevel != "CODE") {
                    //写了children属性就能加载下一级
                    obj.children = [];
                    obj.loading = false;
                }
                return obj;
            });
            item.loading = false;
            callback();
        },
        onTargetChange(val) {
            this.$emit("target-type-change", val[4]);
        }
    }
};
</script>